import type { JobDispatchCarrierGetRequest } from '@trukt/tms-api/JobService';
import { createKey } from '../../createKey';

const keyHandler = createKey('job-dispatch-carrier');

export const JobDispatchCarrierServiceKeys = {
  key: keyHandler.key,
  getById: keyHandler.createMethod<JobDispatchCarrierGetRequest>(),
};
